module.exports = __webpack_public_path__ + "img/b5a6ebf.jpg";